// extracted by mini-css-extract-plugin
export default {"container":"Checkbox_container__yFmAP","inline":"Checkbox_inline__N7t5C","clicked":"Checkbox_clicked__kC1Co","checkbox":"Checkbox_checkbox__ELD7z"};